import { Reducer } from 'redux';
import { appTypes } from './app';

export interface ModalState {
  startFreeTrialModal: boolean;
  inputCardDetailsModal: boolean;
  upgradeSubscriptionModal: boolean;
  downgradeSubscriptionModal: boolean;
  cancelSubscriptionModal: boolean;
  cancelDowngradeModal: boolean;
  configurePaymentMethodModal: boolean;
  changePeriodModal: boolean;
  confirmAutoRenewalModal: boolean;
  noSubscriptionModal: boolean;
}

const storePrefix = 'MODAL';
export const modalTypes = {
  CLOSE_ALL: `${storePrefix}/CLOSE_ALL`,
  START_FREE_TRIAL: `${storePrefix}/START_FREE_TRIAL`,
  INPUT_CARD_DETAILS: `${storePrefix}/INPUT_CARD_DETAILS`,
  UPGRADE_SUBSCRIPTION: `${storePrefix}/TOGGLE_UPGRADE_SUBSCRIPTION`,
  DOWNGRADE_SUBSCRIPTION: `${storePrefix}/DOWNGRADE_SUBSCRIPTION`,
  CANCEL_SUBSCRIPTION: `${storePrefix}/CANCEL_SUBSCRIPTION`,
  CANCEL_DOWNGRADE: `${storePrefix}/CANCEL_DOWNGRADE`,
  CONFIGURE_PAYMENT_METHOD: `${storePrefix}/CONFIGURE_PAYMENT_METHOD`,
  CHANGE_PERIOD: `${storePrefix}/CHANGE_PERIOD`,
  CONFIRM_AUTO_RENEWAL: `${storePrefix}/CONFIRM_AUTO_RENEWAL`,
  NO_SUBSCRIPTION: `${storePrefix}/NO_SUBSCRIPTION`,
};

const initialState: ModalState = {
  startFreeTrialModal: false,
  inputCardDetailsModal: false,
  upgradeSubscriptionModal: false,
  downgradeSubscriptionModal: false,
  cancelSubscriptionModal: false,
  cancelDowngradeModal: false,
  configurePaymentMethodModal: false,
  changePeriodModal: false,
  confirmAutoRenewalModal: false,
  noSubscriptionModal: false,
};

export const modalReducer: Reducer<ModalState> = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case modalTypes.CLOSE_ALL:
    case appTypes.RESET_STATE:
      return initialState;
    case modalTypes.START_FREE_TRIAL:
      return { ...state, startFreeTrialModal: payload.isOpen };
    case modalTypes.INPUT_CARD_DETAILS:
      return { ...state, inputCardDetailsModal: payload.isOpen };
    case modalTypes.UPGRADE_SUBSCRIPTION:
      return { ...state, upgradeSubscriptionModal: payload.isOpen };
    case modalTypes.DOWNGRADE_SUBSCRIPTION:
      return { ...state, downgradeSubscriptionModal: payload.isOpen };
    case modalTypes.CANCEL_SUBSCRIPTION:
      return { ...state, cancelSubscriptionModal: payload.isOpen };
    case modalTypes.CANCEL_DOWNGRADE:
      return { ...state, cancelDowngradeModal: payload.isOpen };
    case modalTypes.CONFIGURE_PAYMENT_METHOD:
      return { ...state, configurePaymentMethodModal: payload.isOpen };
    case modalTypes.CHANGE_PERIOD:
      return { ...state, changePeriodModal: payload.isOpen };
    case modalTypes.CONFIRM_AUTO_RENEWAL:
      return { ...state, confirmAutoRenewalModal: payload.isOpen };
    case modalTypes.NO_SUBSCRIPTION:
      return { ...state, noSubscriptionModal: payload.isOpen };
    default:
      return state;
  }
};

export const modalActions = {
  closeAllModals: () => ({ type: modalTypes.CLOSE_ALL }),
  toggleStartFreeTrialModal: (isOpen: boolean) => ({ type: modalTypes.START_FREE_TRIAL, payload: { isOpen } }),
  toggleInputCardDetailsModal: (isOpen: boolean) => ({ type: modalTypes.INPUT_CARD_DETAILS, payload: { isOpen } }),
  toggleUpgradeSubscriptionModal: (isOpen: boolean) => ({ type: modalTypes.UPGRADE_SUBSCRIPTION, payload: { isOpen } }),
  toggleDowngradeSubscriptionModal: (isOpen: boolean) => ({ type: modalTypes.DOWNGRADE_SUBSCRIPTION, payload: { isOpen } }),
  toggleCancelSubscriptionModal: (isOpen: boolean) => ({ type: modalTypes.CANCEL_SUBSCRIPTION, payload: { isOpen } }),
  toggleCancelDowngradeModal: (isOpen: boolean) => ({ type: modalTypes.CANCEL_DOWNGRADE, payload: { isOpen } }),
  toggleConfigurePaymentMethodModal: (isOpen: boolean) => ({ type: modalTypes.CONFIGURE_PAYMENT_METHOD, payload: { isOpen } }),
  toggleChangePeriodModal: (isOpen: boolean) => ({ type: modalTypes.CHANGE_PERIOD, payload: { isOpen } }),
  toggleConfirmAutoRenewalModal: (isOpen: boolean) => ({ type: modalTypes.CONFIRM_AUTO_RENEWAL, payload: { isOpen } }),
  toggleNoSubscriptionModal: (isOpen: boolean) => ({ type: modalTypes.NO_SUBSCRIPTION, payload: { isOpen } }),
};
